import { useContext } from 'react';
import { useAppSelector } from '../../../../store/redux/hooks';
import { MeContext } from '../../../../context/MeContext';
import { MeContextState } from '../../../../store/types/account';
import { EnhancedDesignType } from '../../../../store/types/template';

export const usePreviewEnhancedDesign = (): EnhancedDesignType | null => {
  const storedDesign = useAppSelector(
    (s) => s.template.appleEnhancedDesign.type
  );
  const meCtx = useContext(MeContext) as { state: MeContextState };
  return meCtx.state.appleEnhancedDesignEnabled ? storedDesign : null;
};
